
import { fadeIn } from './app.js'
import { fadeOut } from './app.js'

// Lightbox for zoom images

if (document.querySelector('.img-zoomer')) {
  function isLast (div) {
    let myPopup = div.closest('.img-zoomer').querySelector('.img-zoomer-full')
    if (div.nextElementSibling) {
      myPopup.querySelector('.img-zoomer-next').classList.remove('inactive')
    } else {
      myPopup.querySelector('.img-zoomer-next').classList.add('inactive')
    }
    if (div.previousElementSibling) {
      myPopup.querySelector('.img-zoomer-prev').classList.remove('inactive')
    } else {
      myPopup.querySelector('.img-zoomer-prev').classList.add('inactive')
    }
  }

  document.querySelectorAll('.img-zoomer .img-zoomer-zoomin').forEach(function(node) {
    node.addEventListener('click', function(e) {
      let myPopup = node.closest('.img-zoomer').querySelector('.img-zoomer-full'),
          myPic = node.closest('.img-zoomer-box').querySelector('img').getAttribute('src')
      myPopup.querySelector('img').setAttribute('src', myPic)
      isLast(node.closest('.img-zoomer-box'))
      fadeIn(myPopup)
      document.querySelector('body').style.overflow = 'hidden'
      node.closest('.img-zoomer-box').classList.add('active')
    })
  })

  function closePopup (node) {
    fadeOut(node.closest('.img-zoomer').querySelector('.img-zoomer-full'))
    document.querySelector('body').style.overflow = 'visible'
    document.querySelectorAll('.img-zoomer-box').forEach(function(node2) {
      node2.classList.remove('active')
    })
  }

  document.querySelectorAll('.img-zoomer .img-zoomer-zoomout').forEach(function(node) {
    node.addEventListener('click', function(e) {
      closePopup(node)
    })
  })

  document.querySelector('.img-zoomer-full-inner').addEventListener('click', function(e) {
    var me = e.target,
        myParents = []
    while (me) {
      myParents.unshift(me)
      me = me.parentNode
    }
    if (document.querySelector('.img-zoomer-full-img-wrapper') != e.target && ! myParents.includes(document.querySelector('.img-zoomer-full-img-wrapper'))){
      closePopup(e.target)
    }
  })

  document.querySelector('.img-zoomer-prev').addEventListener('click', function(e) {
    let myPopup = e.target.closest('.img-zoomer-full'),
        prevBox = e.target.closest('.img-zoomer').querySelector('.img-zoomer-box.active').previousElementSibling,
        myPic = prevBox.querySelector('img').getAttribute('src')
    document.querySelectorAll('.img-zoomer-box').forEach(function(node) {
      node.classList.remove('active')
    })
    prevBox.classList.add('active')
    isLast(prevBox)
    fadeOut(myPopup.querySelector('img'))
    setTimeout(function(){
      myPopup.querySelector('img').setAttribute('src', myPic)
      fadeIn(myPopup.querySelector('img'))
    }, 500)
  })

  document.querySelector('.img-zoomer-next').addEventListener('click', function(e) {
    let myPopup = e.target.closest('.img-zoomer-full'),
        nextBox = e.target.closest('.img-zoomer').querySelector('.img-zoomer-box.active').nextElementSibling,
        myPic = nextBox.querySelector('img').getAttribute('src')
    document.querySelectorAll('.img-zoomer-box').forEach(function(node) {
      node.classList.remove('active')
    })
    nextBox.classList.add('active')
    isLast(nextBox)
    fadeOut(myPopup.querySelector('img'))
    setTimeout(function(){
      myPopup.querySelector('img').setAttribute('src', myPic)
      fadeIn(myPopup.querySelector('img'))
    }, 500)
  })
}
